import { captureException, withScope } from '@sentry/react';
import { dayjs, isArray, isNotEmptyArray, isNotNullOrUndefined } from '@weft/utils';
import { QueryClient, QueryCache, MutationCache } from 'react-query';
import { isSandboxEnvironment } from './env-indicator';
import { setGlobalVariable } from './global-variables/global-variables';

const DEFAULT_QUERY_RETRY_AMOUNT = 2;
const ONE_SECOND_DURATION = dayjs.duration(1, 'second').asMilliseconds();
const FIVE_MINUTE_DURATION = dayjs.duration(5, 'minutes').asMilliseconds();

export const client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: DEFAULT_QUERY_RETRY_AMOUNT,
      retryDelay: ONE_SECOND_DURATION,
      staleTime: FIVE_MINUTE_DURATION,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      withScope(scope => {
        scope.setContext('query', {
          queryHash: query.queryHash,
        });

        if (isNotNullOrUndefined(query.options.queryKey)) {
          const queryKeys = isArray(query.options.queryKey) && isNotEmptyArray(query.options.queryKey) ? query.options.queryKey : [query.options.queryKey];
          const stringifiedQueryKeys = queryKeys.map(queryKey => JSON.stringify(queryKey));
          scope.setFingerprint(stringifiedQueryKeys);
        }

        captureException(error);
      });
    },
  }),
  mutationCache: new MutationCache({
    onMutate: async (_variables, mutation) => {
      if (isSandboxEnvironment()) {
        mutation.options.mutationFn = async () => {};
        setGlobalVariable('showSandboxDialog', true);
      }
    },
    onError: (error, variables, _context, mutation) => {
      withScope(scope => {
        scope.setContext('mutation', {
          mutationId: mutation.mutationId,
          variables,
        });

        if (isNotNullOrUndefined(mutation.options.mutationKey)) {
          const mutationKeys = isArray(mutation.options.mutationKey) && isNotEmptyArray(mutation.options.mutationKey) ? mutation.options.mutationKey : [mutation.options.mutationKey];
          const stringifiedMutationKeys = mutationKeys.map(mutationKey => JSON.stringify(mutationKey));
          scope.setFingerprint(stringifiedMutationKeys);
        }

        captureException(error);
      });
    },
  }),
});